import type { CompanyLpnSetting } from './company-lpn-setting.type.ts';
export interface CompanyLpnSettingExtension extends CompanyLpnSetting {}
export class CompanyLpnSettingExtension {
  get savingsPercentRange(): string | undefined {
    return this.discountPercentRange;
  }

  set savingsPercentRange(value: string | undefined) {
    this.discountPercentRange = value;
  }

  get savingsAmountRange(): string | undefined {
    return this.saveDollarAmountRange;
  }

  set savingsAmountRange(value: string | undefined) {
    this.saveDollarAmountRange = value;
  }
}

const Registration = {
  kind: 'object',
  name: 'company-lpn-setting',
  features: CompanyLpnSettingExtension,
};
export default Registration;
